import React from "react";
import { Stack, Typography } from "@mui/material";

// A label/value row for tooltips and info panels: label on the left, value on the right.
const InfoRow = ({
  label,
  value,
}: {
  label: string;
  value: string | number | null | undefined;
}) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    spacing={3}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: "1em" }}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "1em" }}>
      {value}
    </Typography>
  </Stack>
);

export default InfoRow;
